import * as MUTATION from "@/store/mutation-types";

const state = {
  project_form: {
    step_one: {
      filter: null,
      contacts: [],
      customer_id: null,
      location_id: null,
      sample_type_id: null
    },
    step_two: []
  }
};

const defaultState = () => {
  return {
    step_one: {
      UPDATE_FORM_STATUS: ({ commit }, data) => {
        commit(MUTATION.FORM_STATUS_UPDATE, data);
      },
      filter: null,
      contacts: [],
      customer_id: null,
      grower: null,
      location_id: null,
      sample_type_id: null
    },
    step_two: []
  };
};

const getters = {
  projectForm: state => state.project_form,
  projectFormStepOne: state => state.project_form.step_one,
  projectFormStepTwo: state => state.project_form.step_two,
  projectFormStepTwoSubmission: state => id =>
    state.project_form.step_two.find(submission => submission.id === id)
};

const mutations = {
  STORE_RESET: state => {
    state.project_form = defaultState();
  },
  STEP_ONE_UPDATE: (state, { name, value }) => {
    state.project_form.step_one = {
      ...state.project_form.step_one,
      [name]: value || null
    };
    if (name === "customer_id") {
      state.project_form.step_one.contacts = [];
      state.project_form.step_one.location_id = null;
    }
    if (name === "sample_type_id") {
      state.project_form.step_two = [];
    }
  },
  ADD_SUBMISSION: (state, value) => {
    const submission_list_update = [...state.project_form.step_two];
    submission_list_update.push(value);
    state.project_form.step_two = submission_list_update;
  },
  SUBMISSION_UPDATE: (state, { id, value, name }) => {
    const submission_update = state.project_form.step_two.map(submission => {
      if (submission.id === id) {
        return name
          ? { ...submission, [name]: value }
          : { ...submission, ...value };
      }
      return submission;
    });
    state.project_form.step_two = submission_update;
  },
  SUBMISSION_SAMPLE_UPDATE: (
    state,
    { submission_id, sample_id, sample_update }
  ) => {
    const update = state.project_form.step_two.map(submission => {
      if (submission.id === submission_id) {
        return {
          ...submission,
          samples: submission.samples.map(sample => {
            if (sample.test_package_sample_id === sample_id)
              return sample_update;
            return sample;
          })
        };
      }
      return submission;
    });
    state.project_form.step_two = update;
  },
  SUBMISSION_DELETE: (state, id) => {
    state.project_form.step_two = state.project_form.step_two.filter(
      submission => submission.id !== id
    );
  }
};

const actions = {
  RESET_STORE: ({ commit }) => {
    commit(MUTATION.STORE_RESET);
  },
  UPDATE_STEP_ONE: ({ commit }, data) => {
    commit(MUTATION.STEP_ONE_UPDATE, data);
  },
  ADD_NEW_SUBMISSION: ({ commit }, data) => {
    commit(MUTATION.ADD_SUBMISSION, data);
  },
  UPDATE_SUBMISSION: ({ commit }, data) => {
    commit(MUTATION.SUBMISSION_UPDATE, data);
  },
  UPDATE_SUBMISSION_SAMPLE: ({ commit }, data) => {
    commit(MUTATION.SUBMISSION_SAMPLE_UPDATE, data);
  },
  DELETE_SUBMISSION: ({ commit }, data) => {
    commit(MUTATION.SUBMISSION_DELETE, data);
  }
};

export default {
  getters,
  mutations,
  actions,
  state
};
